import { matchSearchTerms } from "../Utils/htmlStringUtils";

export const filterMatchingNodes = (roots, searchTerms) => {
  if (!searchTerms || !roots.length) return roots;

  return roots.reduce(function recursiveRootItem(previousItem, currentItem) {
    // Make a copy of the previous item to avoid unexpected side effects
    let newPreviousItem = [...previousItem];

    if (currentItem.children) {
      const children = currentItem.children.reduce(recursiveRootItem, []);

      if (children.length) {
        return newPreviousItem.concat({
          ...currentItem,
          children: children
        });
      }
    }

    if (matchSearchTerms(currentItem.title, searchTerms)) {
      return newPreviousItem.concat(currentItem);
    }
    return newPreviousItem;
  }, []);
};
